import {
    elSetCSS,
} from '../utils/element-helpers';

const videoFit = () => {
    const videoFitEls = document.querySelectorAll('[data-video-fit]');
    let videoFrameEl, w, h, ratio, fW, fH, fRatio;

    const resizeVideos = () => {
        videoFitEls.forEach(el => {
            // Ensure container has relative positioning for absolute children
            const computedStyle = window.getComputedStyle(el);
            if (computedStyle.position === 'static') {
                el.style.position = 'relative';
            }

            // Look for iframe first, then video element
            videoFrameEl = el.querySelector('iframe') || el.querySelector('video');

            if (!videoFrameEl) return; // Skip if no video element found

            w = el.offsetWidth;
            h = el.offsetHeight;
            ratio = w/h;

            // For iframes, get width/height from attributes
            if (videoFrameEl.tagName === 'IFRAME') {
                fW = videoFrameEl.getAttribute('width');
                fH = videoFrameEl.getAttribute('height');
            } else {
                // For video elements, use natural dimensions or default to 16:9
                fW = videoFrameEl.videoWidth || 16;
                fH = videoFrameEl.videoHeight || 9;
            }

            fRatio = fW/fH;

            if (w == 0 || h == 0) return;

            if (fRatio > ratio) {
                // Video is wider than container - fit to height
                const videoHeight = h;
                const videoWidth = h * fRatio;
                const translateX = Math.ceil((videoWidth - w) / 2);
                
                elSetCSS(videoFrameEl, {
                    width: `${Math.ceil(videoWidth)}px`,
                    height: `${Math.ceil(videoHeight)}px`,
                    transform: `translateX(${-translateX}px)`,
                });
            } else {
                // Video is taller than container - fit to width
                const videoWidth = w;
                const videoHeight = w / fRatio;
                const translateY = Math.ceil((videoHeight - h) / 2);
                
                elSetCSS(videoFrameEl, {
                    width: `${Math.ceil(videoWidth)}px`,
                    height: `${Math.ceil(videoHeight)}px`,
                    transform: `translateY(${-translateY}px)`,
                });
            }
        });
    }

    // Listen for video metadata loaded event
    document.addEventListener('videometadata', resizeVideos);
    window.addEventListener('resize', resizeVideos);
    resizeVideos();
}

const iframeBlock = () => {
    const iframeBlockEls = document.querySelectorAll('[data-iframe-block]');

    const resizeIframes = () => {
        iframeBlockEls.forEach(el => {
            const iframe = el.querySelector('iframe');

            if (iframe) {
                const iframeWidth = iframe.getAttribute('width');
                const iframeHeight = iframe.getAttribute('height');
                
                iframe.style.width = '100%';
                iframe.style.height = 'auto';
                iframe.style.aspectRatio = `${iframeWidth} / ${iframeHeight}`
            }
        });
    }

    window.addEventListener('resize', resizeIframes);
    resizeIframes();
}

document.addEventListener('DOMContentLoaded', videoFit);
document.addEventListener('DOMContentLoaded', iframeBlock);

export default videoFit;
